import { z } from 'zod'
import { oc } from '@orpc/contract'
import {
  actorOverrideSchema,
  assistantConversationOutputSchema,
  assistantProviderSchema,
} from './assistant-conversation.contract'

export const assistantStart = oc
  .route({ method: 'POST', path: '/v2/assistant/conversations/start' })
  .input(
    z
      .object({
        provider: assistantProviderSchema.optional(),
        model: z.string().min(1).optional(),
        forcedCurrentDate: z
          .string()
          .regex(/^\d{4}-\d{2}-\d{2}$/)
          .optional(),
        // Caller's IANA timezone (e.g. "America/New_York"), supplied by the
        // client from the browser. Used to convert instant dates at the tool
        // boundary; the model stays timezone-agnostic. Invalid values fall back
        // to UTC server-side.
        timezone: z.string().min(1).optional(),
        // Pins the conversation to one patient (in-call "Ask BeAssistant" rail):
        // persisted on the thread and injected as a pinned-patient prompt block
        // every turn. Absent → the regular patient-agnostic Assistant page flow.
        context: z.object({ patientId: z.string().min(1) }).optional(),
        actor: actorOverrideSchema,
      })
      .optional(),
  )
  .output(assistantConversationOutputSchema)
